//TODO: That's our entity reducer
import { Section } from '../../support/custom-hooks/useBreadCrum';
import { Action } from '../actions/usersActions';
import UserEntity from '../../entities/User.Entity';

export interface UsersState {
    roles: Array<number>;
    clientName: string;
    securityRules: Array<string>;
    userName: string;
    breadCrumb: Array<Section>;
    // Cache fields for user profile
    userProfile: UserEntity | null;
    isProfileLoaded: boolean;
    profileLoading: boolean;
    lastProfileFetch: number | null;
}

const initialState: UsersState = {
    roles: [],
    clientName: '',
    securityRules: [],
    userName: '',
    breadCrumb: [],
    // Initialize cache fields
    userProfile: null,
    isProfileLoaded: false,
    profileLoading: false,
    lastProfileFetch: null,
};

export const usersReducer = (state: UsersState = initialState, action: Action) => {
    switch (action.type) {
        case 'MODIFY_USER_ROLES': {
            return { ...state, roles: action.payload };
        }
        case 'MODIFY_CLIENT_NAME': {
            return { ...state, clientName: action.payload };
        }
        case 'MODIFY_USER_SECURITY_RULES': {
            return { ...state, securityRules: action.payload };
        }
        case 'MODIFY_USER_NAME': {
            return { ...state, userName: action.payload };
        }
        case 'MODIFY_BREADCRUMB': {
            return { ...state, breadCrumb: action.payload };
        }
        // New cache actions
        case 'SET_USER_PROFILE': {
            return { 
                ...state, 
                userProfile: action.payload,
                isProfileLoaded: true,
                profileLoading: false,
                lastProfileFetch: Date.now(),
                // Update individual fields for backward compatibility
                roles: action.payload?.userRoles || [],
                clientName: action.payload?.clientName || '',
                securityRules: action.payload?.securityRules || [],
                userName: action.payload ? `${action.payload.firstName || ''} ${action.payload.lastName || ''}`.trim() : ''
            };
        }
        case 'SET_PROFILE_LOADING': {
            return { ...state, profileLoading: action.payload };
        }
        case 'CLEAR_USER_PROFILE': {
            return { 
                ...state, 
                userProfile: null,
                isProfileLoaded: false,
                profileLoading: false,
                lastProfileFetch: null,
                roles: [],
                clientName: '',
                securityRules: [],
                userName: ''
            };
        }
        default: {
            return state;
        }
    }
};
